import {ScorecardRow} from "./row";
import {arrayOrEmpty} from "../../../common/extensions/array";
import {ScoreRow} from "../model/participant-card-model";
import {ScoringMethod, ScoringMethodType} from "../model/scoring-method";
import {ParticipantHoleScore, ParticipantHoleScoreType, StablefordScore, StrokePlayScore} from "../model/hole-score";
import {StablefordTotalScore, StrokePlayTotalScore, TotalScore, TotalScoreType} from "../model/total-score";

export function getScoreRow(row: ScoreRow): ScorecardRow | null {
    if (!row.data) {
        return null;
    }
    return {
        name: getName(row.method),
        outValues: row.data.outValues.map(score => getHoleValue(score)),
        outTotal: getTotalValue(row.data.outTotal),
        inValues: arrayOrEmpty(row.data.inValues).map(score => getHoleValue(score)),
        inTotal: getTotalValue(row.data.inTotal),
        total: getTotalValue(row.data.total) || "",
        classes: ""
    };
}

function getName(method: ScoringMethod): string {
    switch (method.type) {
        case ScoringMethodType.StrokePlay:
            return "Net"
        case ScoringMethodType.Stableford:
            return "Points"
    }
}

function getHoleValue(score: ParticipantHoleScore): string {
    switch (score.type) {
        case ParticipantHoleScoreType.StrokePlayNoScore:
            return ""
        case ParticipantHoleScoreType.StrokePlayPickUp:
            return ""
        case ParticipantHoleScoreType.StrokePlayScore:
            return (score as StrokePlayScore).value.toString()
        case ParticipantHoleScoreType.StablefordScore:
            return (score as StablefordScore).points?.toString() ?? ""
    }
}

function getTotalValue(score: TotalScore | null): string | null {
    switch (score?.type) {
        case TotalScoreType.StrokePlayScore:
            return (score as StrokePlayTotalScore).value?.toString() ?? ""
        case TotalScoreType.StablefordScore:
            return (score as StablefordTotalScore).points?.toString() ?? ""
        case TotalScoreType.Unavailable:
            return "";
        default:
            return null;
    }
}

